import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import MeniuCont from './MeniuCont';
import Logare from '../pagini/Logare';
import Inregistrare from '../pagini/Inregistrare';

function Navbar() {
  const [utilizator, setUtilizator] = useState(null);
  const [modalLogare, setModalLogare] = useState(false);
  const [modalInregistrare, setModalInregistrare] = useState(false);
  const [meniuMobilDeschis, setMeniuMobilDeschis] = useState(false);
  const meniuRef = useRef(null);
  const navigate = useNavigate();

  useEffect(function() {
    const userSalvat = localStorage.getItem('utilizator');
    if (userSalvat) {
      setUtilizator(JSON.parse(userSalvat));
    }
  }, []);

  useEffect(function() {
    function handleClickAfara(e) {
      if (meniuRef.current && !meniuRef.current.contains(e.target)) {
        setMeniuMobilDeschis(false);
      }
    }

    document.addEventListener('mousedown', handleClickAfara);

    return function() {
      document.removeEventListener('mousedown', handleClickAfara);
    };
  }, []);

  useEffect(function() {
    if (meniuMobilDeschis === true) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return function() {
      document.body.style.overflow = '';
    };
  }, [meniuMobilDeschis]);

  function delogare() {
    localStorage.removeItem('token');
    localStorage.removeItem('utilizator');
    setUtilizator(null);
    setModalLogare(false);
    setModalInregistrare(false);
    setMeniuMobilDeschis(false);
    toast.success('Te-ai delogat cu succes!');
    navigate('/');
  }

  function handleDeschideLogare() {
    setModalLogare(true);
  }

  function handleDeschideInregistrare() {
    setModalInregistrare(true);
  }

  function handleInchideLogare() {
    setModalLogare(false);
  }

  function handleInchideInregistrare() {
    setModalInregistrare(false);
  }

  function handleMergiLaInregistrare() {
    setModalLogare(false);
    setModalInregistrare(true);
  }

  function handleMergiLaLogare() {
    setModalInregistrare(false);
    setModalLogare(true);
  }

  function handleLoginSuccess(utilizatorNou) {
    setUtilizator(utilizatorNou);
  }

  function handleToggleMeniuMobil() {
    if (meniuMobilDeschis === true) {
      setMeniuMobilDeschis(false);
    } else {
      setMeniuMobilDeschis(true);
    }
  }

  function handleInchideMeniuMobil() {
    setMeniuMobilDeschis(false);
  }

  function handleLogaresiInchide() {
    setModalLogare(true);
    setMeniuMobilDeschis(false);
  }

  function handleInregistraresiInchide() {
    setModalInregistrare(true);
    setMeniuMobilDeschis(false);
  }

  let prenumeUtilizator = '';
  if (utilizator) {
    const partiNume = utilizator.nume.split(' ');
    prenumeUtilizator = partiNume[0];
  }

  return (
    <>
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16 md:h-20 items-center">

            <Link to="/" className="text-2xl md:text-3xl font-black tracking-tighter text-blue-700 shrink-0">
              TRANZITIO<span className="text-rose-500">.</span>
            </Link>

            <div className="hidden md:flex items-center gap-6 h-full">
              <Link to="/adauga-anunt" className="bg-blue-600 text-white px-6 py-3 rounded-xl font-bold text-sm shadow-md hover:bg-blue-700 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200">
                + Adauga Anunt
              </Link>

              {utilizator ? (
                <div className="flex items-center gap-4 h-full">
                  <div className="flex flex-col text-right">
                    <span className="text-sm font-bold text-gray-800">Salut, {prenumeUtilizator}</span>
                  </div>
                  <div className="h-full border-l border-gray-200 pl-4">
                    <MeniuCont onLogout={delogare} />
                  </div>
                </div>
              ) : (
                <div className="flex items-center gap-2">
                  <button
                    onClick={handleDeschideLogare}
                    className="text-sm font-bold text-gray-700 hover:text-blue-600 px-3 py-2 rounded-lg transition"
                  >
                    Logare
                  </button>
                  <button
                    onClick={handleDeschideInregistrare}
                    className="text-sm font-bold text-blue-700 bg-blue-50 hover:bg-blue-100 px-4 py-2 rounded-lg transition"
                  >
                    Inregistrare
                  </button>
                </div>
              )}
            </div>

            <div className="flex md:hidden items-center gap-3">
              <Link to="/adauga-anunt" className="bg-blue-600 text-white px-4 py-2 rounded-xl font-bold text-xs shadow-md hover:bg-blue-700 transition-all">
                + Anunt
              </Link>
              <button
                onClick={handleToggleMeniuMobil}
                className="p-2 rounded-xl text-gray-600 hover:bg-gray-100 transition"
              >
                {meniuMobilDeschis === true ? (
                  <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                ) : (
                  <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                )}
              </button>
            </div>

          </div>
        </div>

        {meniuMobilDeschis === true && (
          <div ref={meniuRef} className="md:hidden bg-white border-t border-gray-100 shadow-xl">
            <div className="px-4 py-6 space-y-2">

              {utilizator ? (
                <div>
                  <div className="bg-blue-50 rounded-xl px-4 py-3 mb-4">
                    <p className="text-sm text-gray-500 font-medium">Conectat ca</p>
                    <p className="font-bold text-gray-900">{utilizator.nume}</p>
                    <p className="text-xs text-gray-400">{utilizator.email}</p>
                  </div>

                  <Link to="/anunturile-mele" onClick={handleInchideMeniuMobil}
                    className="flex items-center gap-3 px-4 py-3 rounded-xl text-gray-700 font-bold hover:bg-gray-50 transition">
                    <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 002-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                    </svg>
                    Anunturile mele
                  </Link>

                  <Link to="/mesaje" onClick={handleInchideMeniuMobil}
                    className="flex items-center gap-3 px-4 py-3 rounded-xl text-gray-700 font-bold hover:bg-gray-50 transition">
                    <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                    </svg>
                    Mesaje
                  </Link>

                  <Link to="/favorite" onClick={handleInchideMeniuMobil}
                    className="flex items-center gap-3 px-4 py-3 rounded-xl text-gray-700 font-bold hover:bg-gray-50 transition">
                    <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                    </svg>
                    Favorite
                  </Link>

                  <Link to="/comenzi" onClick={handleInchideMeniuMobil}
                    className="flex items-center gap-3 px-4 py-3 rounded-xl text-gray-700 font-bold hover:bg-gray-50 transition">
                    <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                    </svg>
                    Comenzile mele
                  </Link>

                  <Link to="/profil" onClick={handleInchideMeniuMobil}
                    className="flex items-center gap-3 px-4 py-3 rounded-xl text-gray-700 font-bold hover:bg-gray-50 transition">
                    <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                    Profil
                  </Link>

                  <Link to="/setari" onClick={handleInchideMeniuMobil}
                    className="flex items-center gap-3 px-4 py-3 rounded-xl text-gray-700 font-bold hover:bg-gray-50 transition">
                    <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    Setari
                  </Link>

                  <div className="pt-2 border-t border-gray-100 mt-2">
                    <button
                      onClick={delogare}
                      className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-rose-600 font-bold hover:bg-rose-50 transition"
                    >
                      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                      </svg>
                      Delogare
                    </button>
                  </div>
                </div>
              ) : (
                <div>
                  <button
                    onClick={handleLogaresiInchide}
                    className="w-full text-center py-3 rounded-xl font-bold text-gray-700 border border-gray-200 hover:bg-gray-50 transition"
                  >
                    Logare
                  </button>
                  <button
                    onClick={handleInregistraresiInchide}
                    className="w-full text-center py-3 rounded-xl font-bold text-white bg-blue-600 hover:bg-blue-700 transition"
                  >
                    Inregistrare
                  </button>
                </div>
              )}

            </div>
          </div>
        )}
      </nav>

      {modalLogare === true && (
        <Logare
          inchideModal={handleInchideLogare}
          mergiLaInregistrare={handleMergiLaInregistrare}
          onLoginSuccess={handleLoginSuccess}
        />
      )}

      {modalInregistrare === true && (
        <Inregistrare
          inchideModal={handleInchideInregistrare}
          mergiLaLogare={handleMergiLaLogare}
          onLoginSuccess={handleLoginSuccess}
        />
      )}
    </>
  );
}

export default Navbar;